import QRCode from "qrcode-generator";
import Base64 from "base-64";
import zlib from 'react-zlib-js'

export const getQR = (token) => {
    console.log("generating qr code....")
    console.log("Your Token is",token)
    const settings = {
      general: {
        server_url:
          `https://odk.iofe.in/v1/key/${token}/projects/8`,
        constraint_behavior: "on_finalize",
      },
      admin: {
        edit_saved: false,
      },
      project: {
        name: "CFR Boundary Mapping",
        icon: "Q",
        color: "#ff0000",
      },
    };
    const settingsJSON = JSON.stringify(settings); 
    const compressedData = zlib.deflateSync(settingsJSON);
      const base64EncodedData = Base64.encode(compressedData.toString("binary"));
    const qr = QRCode(0, "H");
    qr.addData(base64EncodedData);
    qr.make();
    const qrCodeDataURL = qr.createDataURL(10, 10);

    return qrCodeDataURL;
  }